<template>
  <div class="topdisplayer">
    <p class="filters">{{ title }}</p>
    <p class="date" v-if="!isAvaliacao">{{ start }} a {{ end }}</p>
    <calendario
      class="cl"
      :shortcalendar="true"
      :printmode="true"
      v-if="!isAvaliacao && aulas.length > 0"
      :lang="$i18n.locale"
      :weekstart="currentDate.start"
      :aulas="aulas">
      <template #calendarItem="{smallfont, item, lang, getaulaHeight, columnIndex, hour}">
        <CalendarItem 
          class="citem"
          :smallfont="smallfont"              
          :sala="item.sala_desc"
          :professor="item.docente" 
          :disciplina="item.cadeira" 
          :piso="item.piso"
          :tipo="item.tipo"
          :truncate="false"
          :lang="lang"
          :horaInicio="item.horaInicio" 
          :horaFim="item.horaFim" 
          :duracao="item.duracao"
          :aulaHeight="getaulaHeight(columnIndex, hour, item)"
          :colorbackground="item.bodycolor"
          :colorheader="item.headercolor"
          :showlabel="item.duracao > 3" >
            <template #primary="{truncatedText}">
              {{ truncatedText }}
            </template>
            <template #secondary="{tipo,sala,pisolabel,piso}">
              <template v-if="tipo.length > 0">[{{tipo}}]</template> {{ sala }}
              <template v-if="piso != null">- {{pisolabel}} {{ piso }}</template>
              <br>{{ item.docente }}
            </template>
          </CalendarItem>
        </template>
        <template #popup></template>
    </calendario>
    <EventList
          v-else
          :lang="$i18n.locale"
          :weekstart="currentDate.start"
          :aulas="aulas">
          <template #event="{ sortedCalendario, key, lang, eventColors }">
            <EventItem
              :key="event.id"
              v-for="event in sortedCalendario[key]"
              :lang="lang"
              class="eventItem"
              :colorbackground="eventColors[event.cadeira].body"
              :colorseparador="eventColors[event.cadeira].header"
              :horaInicio="event.horaInicio"
              :horaFim="event.horaFim"
              :disciplina="event.cadeira"
              :tipo="event.tipo"
              :sala="event.sala_desc"
              :ano="event.ano"
              :turma="event.turma"
              :curso="event?.cursos"
              :professor="event.docente">
              <template #titulo>
                {{ event?.cursos ? event?.cursos[0] : "" }}
              </template>
              <template #subtitulolivre>
                {{ $t("avaliacao") }} - {{ event.tipo }} - {{ event.cadeira }}
              </template>
            </EventItem>
          </template>
    </EventList>
  </div>
</template>

<script>
import { computed, toRef } from "vue";
import { i18n } from '@/main.js';
import { useMenuStore } from "@/stores/menu.ts";
import { useHorarios } from "@/stores/horarios.ts";
import { useEventSearch } from "@/stores/eventSearch.ts";

import {
  calendario,
  CalendarItem,
  EventList,
  EventItem,
} from "umaui";

export default {
  props:["isAvaliacao","fields"],
  components: {
    calendario,
    CalendarItem,
    EventList,
    EventItem,
  },
  setup(props){
    const { t } = i18n.global; 

    const menuStore = useMenuStore();
    const selectedOption = computed(() => menuStore.currentSelected);

    const horariosStore = useHorarios();
    const aulas = computed(()=>horariosStore.aulas);
    const eventsearch = useEventSearch();
    const currentDate = computed(()=> eventsearch.selectedWeek);


    const formatter = new Intl.DateTimeFormat("pt-PT", {
        day: "2-digit",
        month: "long",
        year: "numeric"
    });

    const start = computed(() => formatter.format(currentDate.value.start));
    const end = computed(() => formatter.format(currentDate.value.end));


    const filters = computed(() => {
      if(props.fields == null){
        return "";
      }
      const formkeys = Object.keys(props.fields); 
      let filters = [];
      formkeys.forEach(key => {
        if(props.fields[key].value != null){
          filters.push(props.fields[key].value.label)
        }
      });
      return filters.join(" - ");
    })

    const title = computed(() => {
      if(selectedOption.value?.id == 1){
        let p = `${t('labelHorarioCurso')} ${props.fields.curso.value.label} - ${props.fields.ano.value.label}`;
        if(props.fields.disciplina.value != null){
          p = `${t('labelHorarioDisciplina')} ${props.fields.disciplina.value.label} - ${props.fields.curso.value.label} - ${props.fields.ano.value.label}`;
        }
        return p
      }
      if(selectedOption.value?.id == 2){
        return `${t('labelHorarioSala')} ${props.fields.sala.value.label}`;
      }
      if(selectedOption.value?.id == 3){
        let p = `${t('labelHorarioAvalCurso')} ${props.fields.curso.value.label} - ${props.fields.ano.value.label}`;
        if(props.fields.disciplina.value != null){
          p = `${t('labelHorarioAvalDisciplina')} ${props.fields.disciplina.value.label} - ${props.fields.curso.value.label} - ${props.fields.ano.value.label}`;
        }
        return p
      }
      if(selectedOption.value?.id == 4){
        return `${t('labelHorarioDocente')} ${props.fields.docente.value.label}`;
      }
      return filters
    })

    return {
      start,
      end,
      aulas,
      filters,
      currentDate,
      title
    }

  }
}

</script>

<style scoped>

.cl{
  margin-top: 0;
}

.topdisplayer{
  z-index: 99999999;
  background-color: white;
  position: absolute;
  top: 0px;
  left: 0;
  right: 0;
  bottom: 0;
}

.date{
  font-family: "Montserrat Light";
  font-size: 15px;
  display: block;
  width: 100%;
  margin-top: 0;
  margin-bottom: 25px;
}

.filters{
  font-family: "Montserrat";
  margin-top: 25px;
  font-size: 15px;
  margin-bottom: 0;
}

</style>